import { NULL_METRIC } from 'modules/dashboard/utils/dashboardWidgetUtils';

const clickRate = 'ClickRate';
const deliveryRate = 'DeliveryRate';
const totalOpens = 'TotalOpens';
const revenue = 'Revenue';
const totalDelivered = 'TotalDelivered';
const totalPurchases = 'TotalPurchases';
const totalUnsubscribes = 'TotalUnsubscribes';
const totalBounces = 'TotalBounces';
const totalSent = 'TotalSent';

export const MOCK_SETTINGS = {
  defaultStartRange: '-14d',
  defaultEndRange: 'n',
  theme: 'default',
};

export const DEFAULT_GEN_SETTINGS = {
  series: {
    start: {
      min: 120,
      max: 140,
    },
    increase: {
      min: 120,
      max: 140,
    },
  },
  comparison: {
    max: 1000,
    min: 1,
  },
};

export const GENERATIVE_SETTINGS = {
  [totalBounces]: {
    ...DEFAULT_GEN_SETTINGS,
    series: {
      start: {
        min: 7200000,
        max: 7500000,
        modifierFn: ({ value }) => value * 0.05,
      },
      increase: {
        min: 75000,
        max: 140000,
      },
      modifierFn: ({ value, date }) =>
        date.isoWeekday() === 6 || date.isoWeekday() === 7 ? value * 1.04 : value * 0.97,
      randomize: true,
    },
  },
  [totalUnsubscribes]: {
    series: {
      start: {
        min: 6500000,
        max: 7500000,
      },
      increase: {
        min: 75000,
        max: 140000,
      },
      modifierFn: ({ value, date }) =>
        date.isoWeekday() === 6 || date.isoWeekday() === 7 ? value * 0.0018 : value * 0.001,
      randomize: true,
    },
  },
  [totalSent]: {
    series: {
      start: {
        min: 6500000,
        max: 7500000,
      },
      increase: {
        min: 70000,
        max: 140000,
      },
      modifierFn: ({ value, date }) =>
        date.isoWeekday() === 6 || date.isoWeekday() === 7 ? value * 1.04 : value * 0.97,
    },
  },
  [totalOpens]: {
    series: {
      start: {
        min: 6500000,
        max: 7500000,
      },
      increase: {
        min: 70000,
        max: 140000,
      },
      modifierFn: ({ value, date }) =>
        date.isoWeekday() === 6 || date.isoWeekday() === 7 ? value * 0.125 : value * 0.11,
    },
  },
  [revenue]: {
    series: {
      start: {
        min: 75000,
        max: 85000,
      },
      increase: {
        min: 1500,
        max: 1700,
      },
      modifierFn: ({ value, date }) =>
        date.isoWeekday() === 6 || date.isoWeekday() === 7 ? value * 1.04 : value * 0.97,
    },
  },
  [clickRate]: {
    comparison: {
      max: 35,
      min: 15,
    },
  },
  [deliveryRate]: {
    comparison: {
      max: 99,
      min: 95,
    },
  },
  [totalDelivered]: {
    comparison: {
      max: 12500000,
      min: 9500000,
    },
  },
};

export const MOCK_METRICS = {
  clickRate: {
    name: 'Click Rate',
    displayType: 'percentage',
    enumName: clickRate,
    showForMultipleMediums: true,
  },
  deliveryRate: {
    name: 'Delivery Rate',
    displayType: 'percentage',
    enumName: deliveryRate,
    showForMultipleMediums: true,
  },
  totalDelivered: {
    name: 'Total Delivered',
    displayType: 'number',
    enumName: totalDelivered,
    showForMultipleMediums: true,
  },
  totalOpens: {
    name: 'Total Opens',
    displayType: 'number',
    enumName: totalOpens,
    showForMultipleMediums: true,
  },
  revenue: {
    name: 'Revenue',
    displayType: 'currency',
    enumName: revenue,
    showForMultipleMediums: true,
  },
  totalPurchases: {
    name: 'Total Purchases',
    displayType: 'number',
    enumName: totalPurchases,
    showForMultipleMediums: true,
  },
  totalUnsubscribes: {
    name: 'Total Unsubscribes',
    displayType: 'number',
    enumName: totalUnsubscribes,
    showForMultipleMediums: true,
  },
  totalBounces: {
    name: 'Total Bounces',
    displayType: 'number',
    enumName: totalBounces,
    showForMultipleMediums: true,
  },
  totalSent: {
    name: 'Total Sent',
    displayType: 'number',
    enumName: totalSent,
    showForMultipleMediums: true,
  },
  null: NULL_METRIC,
};
